import React from "react";
import * as styles from "./Footer.module.scss";
import NavigationFooter from "./NavigationFooter/NavigationFooter";
import CopyRightFooter from "./CopyRightFooter/CopyRightFooter";
import BackgroundFadeContainer from "@components/BackgroundFadeContainer/BackgroundFadeContainer";
import { GridCol, GridRow } from "@components/GridSystem/GridSystem";

type FooterProps = {
	theme: "light" | "dark";
};

export default function Footer({ theme }: FooterProps) {
	return (
		<div className={theme === "dark" ? styles.Darkbg : styles.Lightbg}>
			<div
				className={
					theme === "dark"
						? styles.fadeBodyDark
						: styles.fadeBodyLight
				}
			>
				<div
					className={`${styles.footer} ${
						theme === "dark"
							? styles.footerdark
							: styles.footerlight
					}`}
				>
					<div className={styles.content}>
						<NavigationFooter theme={theme} />
						<CopyRightFooter theme={theme} />
					</div>
				</div>
			</div>
		</div>
	);
}
